import React from 'react';

const Bard_Explain = () => {
  return (
    <div>
      <h1>Bard_Explain</h1>
      <p>This is the Bard_Explain component.</p>
    </div>
  );
};

export default Bard_Explain;
